import React, { PureComponent } from 'react';
import PropTypes from "prop-types";
import { Modal } from 'antd';

class ModalComponent extends PureComponent {
  render() {
    const {
      title,
      showModal,
      closeModal,
      children,
      width
    } = this.props;

    return (
      <Modal
        title={title}
        //520 is the default width of the modal for antd
        width={width ? width : 520}
        // centered={true}
        visible={showModal}
        footer={null}
        onCancel={closeModal}
        {...this.props}
      >
        {children}
      </Modal>
    )
  }
}

ModalComponent.propTypes = {
  title: PropTypes.string,
  showModal: PropTypes.bool,
  closeModal: PropTypes.func,
  children: PropTypes.node,
}
export default ModalComponent


// WEBPACK FOOTER //
// src/components/modalComponent/ModalComponent.js